import store from '../../rematch';

export const getAuthHeaders = () => {
  const token = store.getState().auth.authToken;
  return token;
};